import Immutable from 'immutable';
import moment from 'moment';
import { logout } from './auth';
import store from 'store2';
import { isBlankNullOrUndefined } from '../../utils/validations';

const LOADER_SHOW = 'billing/LOADER_SHOW';
const LOADER_HIDE = 'billing/LOADER_HIDE';
const LOAD = 'billing/LOAD';
const LOAD_SUCCESS = 'billing/LOAD_SUCCESS';
const LOAD_REPORT_SUCCESS = 'billing/LOAD_REPORT_SUCCESS';
const LOAD_REPORT_FAIL = 'billing/LOAD_REPORT_FAIL';
const LOAD_REPORT_DETAILS_SUCCESS = 'billing/LOAD_REPORT_DETAILS_SUCCESS';
const LOAD_REPORT_DETAILS_FAIL = 'billing/LOAD_REPORT_DETAILS_FAIL';
const LOAD_BILLING_PRACTICES_SUCCESS = 'billing/LOAD_BILLING_PRACTICES_SUCCESS';
const LOAD_BILLING_FAMILY_SUCCESS = 'billing/LOAD_BILLING_FAMILY_SUCCESS';
const LOAD_BILLING_FAMILY_FAIL = 'billing/LOAD_BILLING_FAMILY_FAIL';
const LOAD_BILLING_PRACTICES_FAIL = 'billing/LOAD_BILLING_PRACTICES_FAIL';
const SAVE_TODAY_PRODUCTION = 'billing/SAVE_TODAY_PRODUCTION';
const CHANGE_INTERVAL_REQUEST_COUNT = 'billing/CHANGE_INTERVAL_REQUEST_COUNT';
const LOAD_FAIL = 'billing/LOAD_FAIL';
const SAVE_PARAMS = 'billing/SAVE_PARAMS';
const LOAD_FAMILY = 'billing/LOAD_FAMILY';
const LOAD_TREATMENT_LIST = 'billing/LOAD_TREATMENT_LIST';
const LOAD_TREATMENT_PLAN = 'billing/LOAD_TREATMENT_PLAN';
const LOAD_COMMLOG = 'billing/LOAD_COMMLOG';
const LOAD_APT_RESULT = 'billing/LOAD_APT_RESULT';
const CLOSE_ERROR_MESSAGE = 'billing/CLOSE_ERROR_MESSAGE';
const LOAD_NEXT_DAYS = 'billing/LOAD_NEXT_DAYS';
const LOAD_NEXT_DAYS_SUCCESS = 'billing/LOAD_NEXT_DAYS_SUCCESS';
const FAIL_NEXT_DAYS = 'billing/FAIL_NEXT_DAYS';
const LOAD_MEDICAL = 'billing/LOAD_MEDICAL';
const LOAD_MEDICAL_FAIL = 'billing/LOAD_MEDICAL_FAIL';

const initialState = Immutable.fromJS({
    isLoad: false,
    isNextDaysLoad: false,
    isLoadFamily: false,
    loadErr: null,
    loadErrFamily: null,
    loading: false,
    billingData: null,
    reportData: null,
    billingPractices: null,
    billingParams: '',
    intervalReqCount: 0,
    todayProduction: null,
    familyData: {
        brokenListChild: [],
        aptResult: null,
        treatmentList: null,
        commlog: null,
        treatmentPlan: {},
        lastExamResult: {}
    },
    initialFamilyData: {
        brokenListChild: [],
        aptResult: null,
        treatmentList: null,
        commlog: null,
        treatmentPlan: {},
        lastExamResult: {}
    },
    nextDaysData: null,
    medical: { allergy: [], medication: [], service: [], medical: [], MedUrgNote: [], vitals: [] },
});

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case LOADER_SHOW:
            return state
                .set('isLoad', true)
        case LOADER_HIDE:
            return state
                .set('isLoad', false)
        case LOAD:
            return state
                .set('isLoad', true)
                .set('loadErr', null)
                .set('loadErrFamily', null);
        case CLOSE_ERROR_MESSAGE:
            return state
                .set('loadErr', null)
                .set('loadErrFamily', null);
        case LOAD_SUCCESS:
            return state
                .set('isLoad', false)
                .set('loadErr', null)
                .set('billingData', action.res)
                .set('reportData', null)
                .set('intervalReqCount', 0)
                .set('reportDetailsData', null);
        case LOAD_FAMILY:
            return state
                .set('isLoadFamily', true)
                .set('loadErr', null)
                .set('familyData', action.res);
        case LOAD_TREATMENT_LIST:
            return state
                .set('familyData', Object.assign(action.state, { treatmentList: action.result }));
        case LOAD_TREATMENT_PLAN:
            return state
                .set('familyData', Object.assign(action.state, { treatmentPlan: action.result }));
        case LOAD_COMMLOG:
            return state
                .set('familyData', Object.assign(action.state, { commlog: action.result }));
        case LOAD_APT_RESULT:
            return state
                .set('familyData', Object.assign(action.state, { aptResult: action.result }));
        case LOAD_FAIL:
            return state
                .set('isLoad', false)
                .set('loadErr', action.error)
                .set('billingData', null)
                .set('reportData', {})
                .set('reportDetailsData', {});
        case LOAD_REPORT_SUCCESS:
            return state
                .set('loadErr', null)
                .set('reportData', action.res)
                .set('reportDetailsData', null);
        case LOAD_REPORT_FAIL:
            return state
                .set('isLoad', false)
                .set('loadErr', action.error)
                .set('reportData', null);
        case LOAD_REPORT_DETAILS_SUCCESS:
            return state
                .set('loadErr', null)
                .set('reportDetailsData', action.res);
        case LOAD_REPORT_DETAILS_FAIL:
            return state
                .set('isLoad', false)
                .set('loadErr', action.error)
                .set('reportDetailsData', null);
        case LOAD_BILLING_PRACTICES_SUCCESS:
            return state
                .set('loadErr', null)
                .set('billingPractices', action.res);
        case LOAD_BILLING_FAMILY_SUCCESS:
            return state
                .set('isLoadFamily', false)
                .set('loadErrFamily', null)
                .set('familyData', action.res);
        case LOAD_BILLING_FAMILY_FAIL:
            return state
                .set('isLoadFamily', false)
                .set('loadErrFamily', action.error)
                .set('familyData', {
                    brokenListChild: [],
                    aptResult: [],
                    treatmentList: [],
                    commlog: [],
                    treatmentPlan: {},
                    lastExamResult: {}
                });
        case LOAD_BILLING_PRACTICES_FAIL:
            return state
                .set('isLoad', false)
                .set('loadErr', action.error)
                .set('billingPractices', null);
        case SAVE_PARAMS:
            return state
                .set('billingParams', action.params);
        case CHANGE_INTERVAL_REQUEST_COUNT:
            return state
                .set('intervalReqCount', action.res);
        case SAVE_TODAY_PRODUCTION:
            return state
                .set('todayProduction', action.todayProduction);
        case LOAD_NEXT_DAYS:
            return state
                .set('isNextDaysLoad', true)
                .set('nextDaysData', null);
        case LOAD_NEXT_DAYS_SUCCESS:
            return state
                .set('isNextDaysLoad', false)
                .set('nextDaysData', action.res);
        case FAIL_NEXT_DAYS:
            return state
                .set('nextDaysData', null);
        case LOAD_MEDICAL:
            return state
                .set('medical', action.res);
        case LOAD_MEDICAL_FAIL:
            return state
                .set('medical', { allergy: [], medication: [], service: [], medical: [], MedUrgNote: [] });
        default:
            return state;
    }
};

export const checkCurrentDayData = (abbr, params) => async (dispatch, getState, api) => {
    try {
        const user = getState().get('auth').get('user');
        if (!user.UdaDrList.abbr) {
            dispatch({ type: LOAD_FAIL, error: "Please add Dentist's details" });
        }
        if (user.UdaDrList.abbr !== undefined && user.UdaDrList.abbr !== null) {
            const billingDataObj = { user: user, apiType: 'calendar', abbr: user.UdaDrList.abbr, params: params };
            const res = await api.post(`udr/apix/calendar/${user.UdaDrList.abbr}/unified`, { data: billingDataObj });
            return res;
        }
        return {};
    } catch (err) {
        console.log(err);
    }
}

export const hideErrorModal = () => async (dispatch, getState, api) => {
    dispatch({ type: CLOSE_ERROR_MESSAGE, action: null });
}

export const storeTodayProduction = (billingData, type = 'calendar') => async (dispatch, getState) => {
    let prodAdjWo = 1;
    let user = getState().get('auth').get('user');
    if (user && user.UdaDrList)
        prodAdjWo = user.UdaDrList.prodAdjWo
    let todayProduction = getState().get('billing').get('todayProduction');
    if (!todayProduction) {
        todayProduction = { originalPrice: 0, price: 0, report: null, reportDetails: null, todayPractices: [] }
    }

    const todayDate = moment().format('Y-MM-DD');


    if (type === 'calendar' && billingData && billingData.production.orderByDate && billingData.production.orderByDate[todayDate]) {
        todayProduction.originalPrice = billingData.production.orderByDate[todayDate].price
        todayProduction.price = billingData.production.orderByDate[todayDate].price
        if (billingData.writeoff.orderByDate && billingData.writeoff.orderByDate[todayDate]) {
            todayProduction.price -= billingData.writeoff.orderByDate[todayDate].price
        }
        if (billingData.adjustment.orderByDate && billingData.adjustment.orderByDate[todayDate]) {
            todayProduction.price += billingData.adjustment.orderByDate[todayDate].price
        }
        if (todayProduction.price && todayProduction.price > 0 && prodAdjWo) {
            todayProduction.price = todayProduction.price * prodAdjWo / 100;
        }
        todayProduction.price = todayProduction.price.toFixed(2);
    } else if (type === 'report' && billingData && billingData.production && billingData.production.reportData && Object.keys(billingData.production.reportData).length && billingData.production.reportData[todayDate]) {
        todayProduction.report = billingData.production.reportData[todayDate];
    } else if (type === 'reportDetails' && billingData && billingData.production && billingData.production.reportData && Object.keys(billingData.production.reportData).length && billingData.production.reportData[todayDate]) {
        todayProduction.reportDetails = billingData.production.reportData[todayDate];
    }
    if (type === 'report') {
        let todayPractices = [];
        // Get today practice names
        if (billingData && Object.keys(billingData.production).length && billingData.production.orderByDate[todayDate]) {
            todayPractices = Object.keys(billingData.production.orderByDate[todayDate]);
            if (todayPractices.indexOf('price') >= 0) {
                todayPractices.splice(todayPractices.indexOf('price'), 1);
            }
        }
        todayProduction.todayPractices = todayPractices;
    }
    dispatch({ type: SAVE_TODAY_PRODUCTION, todayProduction: todayProduction });
}

export const storeTodayProductionDr = (billingData, type = 'calendar') => async (dispatch, getState) => {
    let prodAdjWo = 1;
    let user = getState().get('auth').get('user');
    if (user && user.UdaDrList)
        prodAdjWo = user.UdaDrList.prodAdjWo
    let todayProduction = getState().get('billing').get('todayProduction');
    if (!todayProduction) {
        todayProduction = { originalPrice: 0, price: 0, report: null, reportDetails: null, todayPractices: [] }
    }

    const todayDate = moment().format('Y-MM-DD');


    if (type === 'calendar' && billingData && billingData.billingData.production.orderByDate && billingData.billingData.production.orderByDate[todayDate]) {
        todayProduction.originalPrice = billingData.billingData.production.orderByDate[todayDate].price
        todayProduction.price = billingData.billingData.production.orderByDate[todayDate].price
        if (billingData.billingData.writeoff.orderByDate && billingData.billingData.writeoff.orderByDate[todayDate]) {
            todayProduction.price -= billingData.billingData.writeoff.orderByDate[todayDate].price
        }
        if (billingData.billingData.adjustment.orderByDate && billingData.billingData.adjustment.orderByDate[todayDate]) {
            todayProduction.price += billingData.billingData.adjustment.orderByDate[todayDate].price
        }
        if (todayProduction.price && todayProduction.price > 0 && prodAdjWo) {
            todayProduction.price = todayProduction.price * prodAdjWo / 100;
        }
        todayProduction.price = todayProduction.price.toFixed(2);
    } else if (type === 'report' && billingData.billingData && Object.keys(billingData.billingData.production.reportData).length && billingData.billingData.production.reportData[todayDate]) {
        todayProduction.report = billingData.billingData.production.reportData[todayDate];
    } else if (type === 'reportDetails' && billingData.billingData && Object.keys(billingData.billingData.production.reportData).length && billingData.billingData.production.reportData[todayDate]) {
        todayProduction.reportDetails = billingData.billingData.production.reportData[todayDate];
    }
    if (type === 'report') {
        let todayPractices = [];
        // Get today practice names
        if (billingData && Object.keys(billingData.billingData.production).length && billingData.billingData.production.orderByDate[todayDate]) {
            todayPractices = Object.keys(billingData.billingData.production.orderByDate[todayDate]);
            if (todayPractices.indexOf('price') >= 0) {
                todayPractices.splice(todayPractices.indexOf('price'), 1);
            }
        }
        todayProduction.todayPractices = todayPractices;
    }
    dispatch({ type: SAVE_TODAY_PRODUCTION, todayProduction: todayProduction });
}

export const getBillingData = (params, user) => async (dispatch, getState, api) => {
    dispatch({ type: LOAD });
    if (user === null || user === undefined) {
        user = getState().get('auth').get('user');
    }
    const startMonth = params.startDate ? moment(params.startDate).format('Y-M') : moment().format('Y-M');
    const currentMonth = moment().format('Y-M');

    if (!user.UdaDrList.abbr) {
        dispatch({ type: LOAD_FAIL, error: "Please add Dentist's details" });
        return;
    }

    if (params) {
        params = '/' + JSON.stringify(params);
    }
    const billingDataObj = { user: user, apiType: 'calendar', abbr: user.UdaDrList.abbr, params: params };
    try {
        let res;
        if (params.includes("DrPay")) {
            if (user.UdaDrList.abbr !== undefined && user.UdaDrList.abbr !== null) {
                res = await api.post(`udr/apix/calendar/${user.UdaDrList.abbr}/unified`, { data: billingDataObj });
            }
            dispatch({ type: LOAD_SUCCESS, res: res });
            let storeTodayFlag = false;
            // store today data if its not current month
            if (startMonth === currentMonth) {
                dispatch(storeTodayProductionDr(res));
                storeTodayFlag = true;
            }
            if (params) {
                dispatch({ type: SAVE_PARAMS, params: params })
            }

            // Get report data if existingUser
            if (!isBlankNullOrUndefined(res) && res.billingData && Object.keys(res.billingData.production).length) {
                dispatch(getReportData(storeTodayFlag, false, user));
            }
            return res;
        } else {
            dispatch({ type: LOADER_SHOW });
            res = await api.get(`udr/api/calendar/${user.UdaDrList.abbr}${params}`);
            dispatch({ type: LOAD_SUCCESS, res: res });
            let storeTodayFlag = false;
            // store today data if its not current month
            if (startMonth === currentMonth) {
                dispatch(storeTodayProduction(res));
                storeTodayFlag = true;
            }
            if (params) {
                dispatch({ type: SAVE_PARAMS, params: params })
            }

            // Get report data if existingUser
            if (res && Object.keys(res.production).length && !params.includes("DrPay")) {
                dispatch(getReportData(storeTodayFlag));
            }
            return res;
        }

    } catch (err) {
        dispatch({ type: LOAD_FAIL, error: err.message });
    }
};

export const getNextDaysData = (params = '', load = '') => async (dispatch, getState, api) => {
    if (load !== '')
        dispatch({ type: LOAD_NEXT_DAYS });
    let user = getState().get('auth').get('user');
    if (params) {
        const currentMonth = moment().format('Y-MM-01');
        if (params.startDate === currentMonth) {
            params.startDate = moment().format('Y-MM-DD');
        }
        params = '/' + JSON.stringify(params);
    } else {
        const startDate = moment().format('Y-MM-DD');
        params = {
            startDate: startDate,
            endDate: moment(startDate).endOf('month').format('Y-MM-DD')
        }
        params = '/' + JSON.stringify(params);
    }
    try {
        let res = await api.get(`udr/api/next-days/${user.UdaDrList.abbr}/${user.UdaDrList.userId}${params}`);
        dispatch({ type: LOAD_NEXT_DAYS_SUCCESS, res: res });
        return res;
    } catch (err) {
        dispatch({ type: FAIL_NEXT_DAYS, error: err.message });
    }
};


export const getReportData = (storeTodayFlag, url = false, users) => async (dispatch, getState, api) => {
    dispatch({ type: LOADER_SHOW });
    let params = getState().get('billing').get('billingParams');
    let user = users ? users : getState().get('auth').get('user');
    let dispatchResponse = false;
    try {
        if (!url) {
            url = `udr/api/details1/${user.UdaDrList.abbr}${params}`;
            dispatchResponse = true;
        }
        let res = await api.get(url);
        if (dispatchResponse) {
            dispatch({ type: LOAD_REPORT_SUCCESS, res: res });
        }

        // store today data if its not current month
        if (storeTodayFlag) {
            dispatch(storeTodayProduction(res, 'report'));
        }
        dispatch(getReportDetailsData(storeTodayFlag));
        return res;
    } catch (err) {
        dispatch({ type: LOAD_REPORT_FAIL, error: err.message });
    }
};

export const getReportDetailsData = (storeTodayFlag, url = false) => async (dispatch, getState, api) => {
    dispatch({ type: LOADER_SHOW });
    let params = getState().get('billing').get('billingParams');
    let user = getState().get('auth').get('user');
    let dispatchResponse = false;
    if (!url) {
        url = `udr/api/details2/${user.UdaDrList.abbr}${params}`;
        dispatchResponse = true;
    }
    try {
        let res = await api.get(url);
        if (dispatchResponse) {
            dispatch({ type: LOAD_REPORT_DETAILS_SUCCESS, res: res });
        }

        // store today data if its not current month
        if (storeTodayFlag) {
            dispatch(storeTodayProduction(res, 'reportDetails'));
        }

        return res;
    } catch (err) {
        dispatch({ type: LOAD_REPORT_FAIL, error: err.message });
    } finally {
        dispatch({ type: LOADER_HIDE });
    }
};

export const getBillingDetails = (abbr) => async (dispatch, getState, api) => {
    try {
        let res = await api.get(`udr/api/udrBillingDetails/${abbr}`);
        dispatch({ type: LOAD_BILLING_PRACTICES_SUCCESS, res: res });
        return res;
    } catch (err) {
        dispatch({ type: LOAD_BILLING_PRACTICES_FAIL, error: err.message });
    }
};
export const getMedical = (patientId, practice) => async (dispatch, getState, api) => {
    try {

        api.get(`udr/api/medical/${patientId}/${practice}`)
            .then(medical => {
                dispatch({ type: LOAD_MEDICAL, res: medical });
            });
    } catch (err) {
        dispatch({ type: LOAD_MEDICAL_FAIL, res: null });
    }
}
export const getFamilyPatientDetails = (patientId, practice) => async (dispatch, getState, api) => {
    let res = Object.assign({}, getState().get('billing').get('familyData'));
    res.aptResult = null;
    res.treatmentList = null;
    res.commlog = null;
    dispatch({ type: LOADER_SHOW });
    let params = { "func": "brokenListChild", "location": practice, "PatNum": patientId, "Guarantor": patientId }
    try {
        params.func = 'tablePTLInfo';
        const treatmentListPromise = api.get(`udr/broken-api/${JSON.stringify(params)}`)

        params.func = 'tableCLHInfo';
        const commlogPromise = api.get(`udr/broken-api/${JSON.stringify(params)}`)

        params.func = 'aptResult';
        const aptResultPromise = api.get(`udr/broken-api/${JSON.stringify(params)}`)

        Promise.all([treatmentListPromise, commlogPromise, aptResultPromise]).then((values) => {
            res.treatmentList = values[0];
            res.commlog = values[1];
            res.aptResult = values[2];
            dispatch({ type: LOAD_FAMILY, res: res });
            dispatch({ type: LOADER_HIDE });
        });

        return res;
    } catch (err) {
        dispatch({ type: LOAD_BILLING_FAMILY_FAIL, error: 'Family view api failed. Error: ' + err.message });
    }
};

export const getFamilyPatients = (patientId, practice) => async (dispatch, getState, api) => {
    let res = Object.assign({}, getState().get('billing').get('initialFamilyData'));
    dispatch({ type: LOADER_SHOW });
    let params = { "func": "brokenListChild", "location": practice, "PatNum": patientId, "Guarantor": patientId }
    try {
        res.brokenListChild = await api.get(`udr/broken-api/${JSON.stringify(params)}`);
        if (res.brokenListChild && res.brokenListChild.length) {
            params.func = 'tablePTLInfo';
            const treatmentListPromise = api.get(`udr/broken-api/${JSON.stringify(params)}`)

            params.func = 'tableCLHInfo';
            const commlogPromise = api.get(`udr/broken-api/${JSON.stringify(params)}`)

            params.func = 'tableOTPInfo';
            const treatmentPlanPromise = api.get(`udr/broken-api/${JSON.stringify(params)}`)

            params.func = 'aptResult';
            const aptResultPromise = api.get(`udr/broken-api/${JSON.stringify(params)}`)

            Promise.all([treatmentListPromise, commlogPromise, treatmentPlanPromise, aptResultPromise]).then((values) => {
                res.treatmentList = values[0];
                res.commlog = values[1];
                res.treatmentPlan = values[2];
                res.aptResult = values[3];
                dispatch({ type: LOAD_FAMILY, res: res });
                dispatch({ type: LOADER_HIDE });
            });

            dispatch(fetchInsuranceDetails(params, res))
        } else {
            dispatch({ type: LOAD_BILLING_FAMILY_FAIL, error: "Family view api failed." });
        }
    } catch (err) {
        dispatch({ type: LOAD_BILLING_FAMILY_FAIL, error: 'Family view api failed. Error: ' + err.message });
    }
};

export const fetchInsuranceDetails = (params, res) => async (dispatch, getState, api) => {
    params.PT_Num = []
    res.brokenListChild.forEach(item => {
        params.PT_Num.push(item.PT_Num);
    });
    let temp = {};
    const patientObjects = [];
    params.func = 'insurance';
    const response = await api.get(`udr/broken-api/${JSON.stringify(params)}`);
    const BrokenChild = res.brokenListChild;
    if (response && response.length) {
        for (let i = 0; i < BrokenChild.length; i++) {
            temp = Object.assign({}, BrokenChild[i]);
            for (let j = 0; j < response.length; j++) {
                if (response[j].PatNum === temp.PatNum) {
                    temp.Insurance = {};
                    temp.Insurance.DateLastVerified = response[j].DateLastVerified;
                    temp.Insurance.Insurance = response[j].Insurance;
                    temp.Insurance.Visit_Count = response[j].Visit_Count;
                    temp.Insurance.show_rate = response[j].show_rate;
                    temp.Insurance.total_apts = response[j].total_apts;
                }
            }
            patientObjects.push(temp);
        }
        res.brokenListChild = patientObjects;
    }
    return res;
}

export const updateReportData = (param) => async (dispatch, getState, api) => {
    try {
        let user = getState().get('auth').get('user');
        const details1 = `udr/api/details1/${user.UdaDrList.abbr}${param}`;
        const details2 = `udr/api/details2/${user.UdaDrList.abbr}${param}`;
        const storeTodayFlag = true;
        dispatch(getReportData(storeTodayFlag, details1));
        dispatch(getReportDetailsData(storeTodayFlag, details2));
        return true;
    } catch (err) {
        dispatch({ type: LOAD_BILLING_PRACTICES_FAIL, error: err.message });
    }
};

export const saveParams = (params) => async (dispatch) => {
    try {
        dispatch({ type: SAVE_PARAMS, params: params });
        return;
    } catch (err) {
        dispatch({ type: LOAD_BILLING_PRACTICES_FAIL, error: err.message });
    }
}

export const sendDrNote = (reportObj) => async (dispatch, getState, api) => {
    try {
        let res = await api.post('udr/sendDrNote', { data: reportObj });
        dispatch({ type: LOAD_BILLING_PRACTICES_SUCCESS, res: res });
        return res;
    } catch (err) {
        dispatch({ type: LOAD_BILLING_PRACTICES_FAIL, error: err.message });
    }
};

export const sendReport = (reportObj) => async (dispatch, getState, api) => {
    reportObj.params = getState().get('billing').get('billingParams');

    Object.assign(reportObj, { timeStamp: moment().format('DD-MMMM-YYYY-hh:mmA') });

    try {
        let res = await api.post('udr/sendReport', { data: reportObj });
        dispatch({ type: LOAD_BILLING_PRACTICES_SUCCESS, res: res });
        return res;
    } catch (err) {
        dispatch({ type: LOAD_BILLING_PRACTICES_FAIL, error: err.message });
    }
};

export const sendReportGox = (title) => async (dispatch, getState, api) => {
    const GoxList = getState().get('billing').get('billingData').GoxList;
    dispatch({ type: LOADER_SHOW });
    try {
        let res = await api.post('udr/sendReportGox', { data: { title, GoxList } });
        dispatch({ type: LOADER_HIDE });
        return res;
    } catch (err) {
        dispatch({ type: LOADER_HIDE });
    }
};

export const sendReportCollections = (title, detailsModal, collectionsList, collEntryStartDate, collProcStartDate) => async (dispatch, getState, api) => {
    dispatch({ type: LOADER_SHOW });
    try {
        let res = await api.post('udr/sendReportCollections', {
            data: {
                title,
                collections: collectionsList,
                detailsModal,
                collEntryStartDate,
                collProcStartDate
            }
        });
        dispatch({ type: LOADER_HIDE });
        return res;
    } catch (err) {
        dispatch({ type: LOADER_HIDE });
        console.log('err', err);
    }
};
export const sendFamilyReport = (reportObj) => async (dispatch, getState, api) => {
    Object.assign(reportObj, { timeStamp: moment().format('DD-MMMM-YYYY-hh:mmA') });
    try {
        let res = await api.post('udr/sendFamilyReport', { data: reportObj });
        return res;
    } catch (err) {
        dispatch({ type: LOAD_FAIL, error: err.message });
    }
};

export const changeIntervalReqCount = () => async (dispatch, getState, api) => {
    let intervalReqCount = getState().get('billing').get('intervalReqCount');
    intervalReqCount = (intervalReqCount < 10) ? intervalReqCount + 1 : 0;
    dispatch({ type: CHANGE_INTERVAL_REQUEST_COUNT, res: intervalReqCount });
};

export const saveUdaUsageReport = (module, loginVia, deviceOS, dispatch, getState, api) => {
    const user = getState().get('auth').get('user');
    if (!user || !user.id) {
        setTimeout(function () {
            saveUdaUsageReport(module, loginVia, deviceOS, dispatch, getState, api)
        }, 1000);
        return false;
    }
    let udaRole = [];
    const loginWithForm = store('loginWithForm');
    if (!user || loginWithForm) {
        return false; //Don't save usage if login with form by admin
    }
    if (user && user.UdrUsersPermissions && user.UdrUsersPermissions.length) {
        user.UdrUsersPermissions.forEach(item => {
            if (item.UdrPermission) udaRole.push(item.UdrPermission.role);
        });
    }
    try {
        api.post('udr/saveUdaUsages', {
            data: {
                userId: user.id,
                firstName: user.firstname,
                lastName: user.lastname,
                udaRole: udaRole.join(","),
                loginVia: loginVia,
                module: module,
                deviceOS: deviceOS
            }
        });
        return true;
    } catch (err) {
        dispatch({ type: LOAD_BILLING_PRACTICES_FAIL, error: err.message });
    }
};

export const saveUdaUsage = (module, loginVia, deviceOS) => async (dispatch, getState, api) => {
    const user = getState().get('auth').get('user');
    if (!user || !user.id) {
        setTimeout(function () {
            saveUdaUsageReport(module, loginVia, deviceOS, dispatch, getState, api)
        }, 1000);
    } else {
        saveUdaUsageReport(module, loginVia, deviceOS, dispatch, getState, api);
    }
};

export const checkUserActivity = () => async (dispatch, getState, api) => {
    const user = getState().get('auth').get('user');
    if (!user) {
        // logout here
        dispatch(logout());
        return false;
    }

    try {
        const res = await api.post('udr/checkUserActivity', { data: { userId: user.id } });
        if (!res) {
            dispatch(logout());
            return false;
        }
        return true;
    } catch (err) {
        // Only logout on authentication errors (401, 403)
        // For other errors (timeout, network issues), don't logout
        if (err.code === 401 || err.code === 403) {
            dispatch(logout());
            return false;
        }
        dispatch({ type: LOAD_BILLING_PRACTICES_FAIL, error: err.message });
        return true; // Don't interrupt user session for non-auth errors
    }
};
